import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Socket } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';
import { AuthService } from '../login/auth.service';
import { CreateEngineDto, Engine, SearchEngineDto } from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class EngineService {
  constructor(private http: HttpClient, private authService: AuthService, private socket: Socket) {}

  newEngineGW = this.socket.fromEvent<Engine>('engineChanges');

  create(payload: CreateEngineDto): Observable<Engine> {
    return this.http.post<Engine>(`${environment.BACKEND}/engine/create`, payload);
  }

  search(payload?: SearchEngineDto): Observable<{ data: Engine[]; length: number }> {
    return this.http.post<{ data: Engine[]; length: number }>(
      `${environment.BACKEND}/engine/search`,
      payload
    );
  }
}
